// Sample card from Airbnb
import React from "react";
import { useNavigate } from "react-router-dom"; 

import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Form from "react-validation/build/form";
import { Alert } from 'react-bootstrap';
import APIConfig from "../../../../api/APIConfig";
import swal from 'sweetalert';
import classes from "./styles.module.css"; 

import {
    Box,
    Center,
    Heading,
    Button,
    Stack,
    Text,
    VStack,
    useColorModeValue,
    FormControl,
    FormLabel,
    Input,
} from '@chakra-ui/react';

function FormDetailRekeningPeserta() {
    const navigate = useNavigate();
    const [namaRekening, setNamaRekening] = useState('');
    const [namaBank, setNamaBank] = useState('');
    const [nomorRekening, setNomorRekening] = useState('');
    const [validation, setValidation] = useState({});
    const { id } = useParams();

    useEffect(() => {
        getPesertaById();
        
    }, []);
    
    const getPesertaById = async() => {
        const response = await APIConfig.get(`/v1/peserta/${id}`);
        const data = await response.data
        setNamaBank(data.namaBank);
        setNamaRekening(data.namaRekening);
        setNomorRekening(data.nomorRekening);
    };

    const updateRekening = async (e) => {
        e.preventDefault();
        console.log("masuk")        
        swal("Apakah Anda yakin ingin mengubah data rekening?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
            }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`v1/detailRekening/peserta/${id}`, {
                    namaBank: namaBank,
                    namaRekening: namaRekening,
                    nomorRekening: nomorRekening   
                })
                swal({
                    title: "Detail rekening berhasil tersimpan!",
                    icon: "success",
                    button: "OK",
                })
                .then(() => {
                    navigate(`/peserta/profile/rekening/${id}`)
                })
                .catch((error) => {
                    console.log(error);
                    setValidation(error.response.data);
                })
            }
            return false;
        });
    };

    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Edit Profil
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        color={useColorModeValue('gray.700', 'white')}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Kontak Pribadi
                    </Heading>
                    
                    {
                        validation.errors &&
                            <Alert variant="danger">
                                <ul class="mt-0 mb-0">
                                    { validation.errors.map((error, index) => (
                                        <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                    )) }
                                </ul>
                            </Alert>
                    }

                    <Form onSubmit={updateRekening}>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='namaRekening'>Nama Rekening</FormLabel>
                        <Input 
                            id='namaRekening' 
                            placeholder='Masukkan nama rekening'
                            value={namaRekening}
                            onChange={(e) => setNamaRekening(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='namaBank'>Nama Bank</FormLabel>
                        <Input 
                            id='namaBank' 
                            placeholder='Masukkan nama bank'
                            value={namaBank}
                            onChange={(e) => setNamaBank(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='nomorRekening'>Nomor Rekening</FormLabel>
                        <Input 
                            id='nomorRekening' 
                            placeholder='Masukkan nomor rekening'
                            value={nomorRekening}
                            onChange={(e) => setNomorRekening(e.target.value)}/>
                        </FormControl>

                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                loadingText='Submitting'
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Simpan
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default FormDetailRekeningPeserta;